import * as types from './types';
import { NETWORK_STATUS } from '~/utils/config';

const initialState = {
  statusFollowing: NETWORK_STATUS['NONE'],
  defaultNetWork: NETWORK_STATUS['NONE'],
  browserUserInfo: {},
};

const userDetailsReducer = (state = initialState, action) => {
  const browserUserInfo = action.payload;
  const type = action.type;
  switch (type) {
    case types.UPDATE_ONLINE: {
      return {
        ...state,
        defaultNetWork: NETWORK_STATUS['ONLINE'],
        statusFollowing: NETWORK_STATUS['JUST_ONLINE'],
      };
    }
    case types.UPDATE_OFFLINE: {
      return {
        ...state,
        defaultNetWork: NETWORK_STATUS['OFFLINE'],
        statusFollowing: NETWORK_STATUS['JUST_OFFLINE'],
      };
    }
    case types.UPDATE_WEAK: {
      return {
        ...state,
        defaultNetWork: NETWORK_STATUS['WEAK'],
      };
    }
    case types.RESET_NETWORK: {
      return {
        ...state,
        defaultNetWork: NETWORK_STATUS['NONE'],
      };
    }
    case types.RESET_FOLLOWING: {
      return {
        ...state,
        statusFollowing: NETWORK_STATUS['NONE'],
      };
    }
    case types.SAVE_USER_INFO: {
      return {
        ...state,
        browserUserInfo,
      };
    }
    case types.RESET_ALL_NETWORK: {
      return initialState;
    }
    default:
      return state;
  }
};
export default userDetailsReducer;
